import React from 'react';
import { useDrop } from 'react-dnd';
import { v4 as uuid } from 'uuid';
import { IColumnView, IDragColumnView } from '../../document-list/interface/custom-view';
import Field from './field';

interface ISelectedFieldContainerProps {
  customViewList: IColumnView[];
  addCustomViewList(item: IDragColumnView): void;
  arrangeSequence(dragItem: IDragColumnView, field: IColumnView): void;
  onClick?(field: IColumnView): void;
  deleteColumn(field: IColumnView): void;
}

const SelectedFieldContainer: React.FC<ISelectedFieldContainerProps> = (props) => {
  // eslint-disable-next-line
  const [collectedProps, dropRef] = useDrop({
    accept: 'column-field',
    drop: (selectedItem: IDragColumnView) => {
      if (selectedItem.data.new === true) {
        props.addCustomViewList(selectedItem);
      }
    }
  })
  return (
    <div ref={dropRef} className='selected-field-container'>
      {
        props.customViewList.map((field: IColumnView) => {
          return <Field
            arrangeSequence={props.arrangeSequence}
            onClick={props.onClick}
            allowDrop={true}
            key={`selected-field-key-${uuid()}`}
            field={field}
            deleteColumn={props.deleteColumn}
          />
        })
      }
    </div>
  );
}

export default SelectedFieldContainer;